import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Planejamento",
  path: "/prestacaocontas/pcoplanejamento",
  name: "pcoplanejamento",
  component: () => import("@/views/prestacaocontas/pcoplanejamento/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.PLANEJAMENTOSECRETARIANOVO_MENU_2900100199],
  },
  goesToMenu: true,
 },
]
